import { render, staticRenderFns } from "./EventContest.vue?vue&type=template&id=424856e7&scoped=true"
import script from "./EventContest.vue?vue&type=script&lang=ts"
export * from "./EventContest.vue?vue&type=script&lang=ts"
import style0 from "./EventContest.vue?vue&type=style&index=0&id=424856e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424856e7",
  null
  
)

export default component.exports